<template>
  <div class="content">
    <div class="toptit">
      <span>解决方案</span>
      <img src="../../assets/solution/SOLUTION.png" alt="" />
    </div>
    <div class="pic">
      <div class="production">
        <img :src="url" alt="" />
      </div>

      <div class="change">
        <div class="eveclick" :style="back">
          <div v-show="flag" class="show"></div>
          <span @click="goPage">智能防窃电解决方案</span>
          <img @click="gonext" v-show="flag" src="../../assets/solution/arrow.png" alt="" />
        </div>
        <div class="eveclick" :style="back2">
          <div v-show="flag2" class="show"></div>
          <span @click="goPage2">BMS蓄电池智能监测解决方案</span>
          <img @click="gonext2" v-show="flag2" src="../../assets/solution/arrow.png" alt="" />
        </div>
        <div class="eveclick" :style="back3">
          <div v-show="flag3" class="show"></div>
          <span @click="goPage3">智能远程抄表解决方案</span>
          <img @click="gonext3" v-show="flag3" src="../../assets/solution/arrow.png" alt="" />
        </div>
        <div class="eveclick" :style="back4">
          <div v-show="flag4" class="show"></div>
          <span @click="goPage4">铅酸电池修复解决方案</span>
          <img @click="gonext4" v-show="flag4" src="../../assets/solution/arrow.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datalist: [],
      flag: true,
      flag2: false,
      flag3: false,
      flag4: false,
      back: "background:#0764C4",
      back2: "",
      back3: "",
      back4: "",
      url: require("../../assets/solution/zu1.png"),
    };
  },
  methods: {
    goPage() {
      console.log(1);
      this.back = "background:#0764C4";
      this.back2 = "";
      this.back3 = "";
      this.back4 = "";
      this.flag = true;
      this.flag2 = false;
      this.flag3 = false;
      this.flag4 = false;
      this.url = require("../../assets/solution/zu1.png");
    },
    goPage2() {
      console.log(2);
      this.back2 = "background:#0764C4";
      this.back = "";
      this.back3 = "";
      this.back4 = "";
      this.flag2 = true;
      this.flag = false;
      this.flag3 = false;
      this.flag4 = false;
      this.url = require("../../assets/solution/zu3.png");
    },
    goPage3() {
      console.log(3);
      this.back3 = "background:#0764C4";
      this.back2 = "";
      this.back = "";
      this.back4 = "";
      this.flag3 = true;
      this.flag2 = false;
      this.flag = false;
      this.flag4 = false;
      this.url = require("../../assets/solution/zu2.png");
    },
    goPage4() {
      console.log(4);
      this.back4 = "background:#0764C4";
      this.back2 = "";
      this.back3 = "";
      this.back = "";
      this.flag4 = true;
      this.flag2 = false;
      this.flag3 = false;
      this.flag = false;
      this.url = require("../../assets/solution/zu4.png");
    },
    gonext() {
      this.$router.push({
        path: "/solution",
        query:{
          id:1
        }
      });
    },
    gonext2() {
      this.$router.push({
        path: "/solution",
        query:{
          id:2
        }
      });
    },
    gonext3() {
      this.$router.push({
        path: "/solution",
        query:{
          id:3
        }
      });
    },
    gonext4() {
      this.$router.push({
        path: "/solution",
        query:{
          id:4
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 650px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .toptit {
    display: flex;
    flex-direction: column;
    // margin-right: 500px;
    margin-left: 600px;
    span {
      font-size: 40px;
      font-family: NotoSansHans-Regular, NotoSansHans;
      font-weight: 400;
      color: #333333;
      margin-left: 450px;
    }
    img {
      width: 576px;
      height: 66px;
      margin-top: -20px;
    }
  }
  .pic {
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 20px;
    // margin-left: 20px;
    .production {
      width: 65%;
      // border: 1px solid red;
      img {
        width: 100%;
      }
    }
    .change {
      width: 25%;
      height: 384px;
      background: #0d75dd;
      opacity: 1;
      display: flex;
      flex-direction: column;
      margin-left: -50px;
      .eveclick {
        width: 100%;
        height: 96px;
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        padding: 0px 10px 0px 0px;
        box-sizing: border-box;
        cursor: pointer;
        span {
          font-size: 20px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #ffffff;
          margin: auto;
        }
        .show {
          width: 6px;
          height: 96px;
          background: #f1bb2b;
          opacity: 1;
        }
        img {
          width: 26px;
          height: 26px;
        }
      }
      span {
        font-size: 20px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>